// @flow

import * as React from 'react';

/**
 * Wrapper around a horizontal rule with styling options
 *
 * @author wsong
 * @since May 2018
 */

type Props = {
  index: number,
  size: number,
  separator: string,
};

export default function Separator(props: Props) {
  if (props.index < props.size - 1) {
    return <span>{props.separator}</span>;
  }
  return null;
}
